/**
 * @module app.portal.updateUserCtrl
 *
 */
define(['angular', 'moment'], function(angular, moment) {


    function UpdateUserCtrl($scope, $uibModalInstance, user, roles, users) {
        let self = {};
        self.user = user[0];
        self.roles = roles;
        self.users = users;
        self.manager = self.users.filter(
            user =>
                user.role !== null &&
                user.role !== 'ANCIEN_RDS' &&
                user.role !== 'RDS' &&
                user.role !== 'TELEPRO' &&
                user.role !== 'CS' &&
                user.role !== 'CSD' &&
                user.role !== 'AC' &&
                user.role !== 'CUP'
        );
        self.telepros = self.users.filter(tel => tel.role === 'TELEPRO');
        self.css = self.users.filter(tel => tel.role === 'CS');

        self.send = function() {
            $uibModalInstance.close({
                user: self.user
            });
        };

        self.cancel = function() {
            $uibModalInstance.dismiss('cancel');
        };

        return self;
    }

    UpdateUserCtrl.$inject = ['$scope', '$uibModalInstance', 'user', 'roles', 'users'];

    angular.module('app.portal.updateUserCtrl', ['ui.bootstrap']).controller('UpdateUserCtrl', UpdateUserCtrl);
});
